export const AVAILABLE_VALIDATIONS: any = {
    PHOTO_ONLY_UPDATE: 'Photo Only Update',
    PHOTO_UPDATE_ONLY_PSD_CHANGE: 'Photo Update and PSD Only Change',
    PHOTO_UPDATE_PSD_CFSD_CHANGE: 'Photo Update and PSD and CFSD Change',
    PHOTO_UPDATE_ONLY_CFSD_CHANGE: 'Photo Update and CFSD Only Change'
}

export const PLACARD_STATUS_VERIFICATION: any = {
    DISPATCHED: 'Dispatched',
    INACTIVE: 'Inactive',
    PENDING: 'Pending',
    ACTIVE: 'Active',
    REJECTED: 'Rejected',
    AGED: 'Aged'
}

export const ERROR_IMG_FILE: any = {
    ERROR_FILE_MAX: 'errorFileMax',
    ERROR: 'error'
}